<template>
  <div>
    <el-dialog title="额度充值" :visible.sync="payShow" width="500px" :append-to-body="true" class="custom-el-wrapper">
      <div class="gx-wallet__modal-body">
        <div class="gx-wallet__modal-label">选择额度</div>
        <div class="gx-wallet__modal-grid">
          <button
              v-for="(a, i) in option_list"
              :key="i"
              class="gx-wallet__modal-amt"
              :class="{ 'gx-wallet__modal-amt--on':payType===1 && thisNum === a }"
              @click="onGoodsPay(1,a)"
          >
            <div class="gx-wallet__modal-amt-v">{{ a }}</div>
            <div class="gx-wallet__modal-amt-u" v-if="unit">{{ unit }}</div>
          </button>
        </div>

        <div class="gx-wallet__modal-label">其他</div>
        <div class="custom-el-wrapper"  @click="onGoodsPay(2)">
          <el-input-number  placeholder="请输入数量" :min="min_num || 1" v-model="otherNum" :step="1" :precision="0" style="width: 140px"
                            size="small"></el-input-number>
          {{ unit }}
        </div>

        <div class="gx-wallet__modal-price">
          <span>余额支付
            <span style="font-size: 12px;color: #409eff;">（可用余额：{{ userInfo.money }}）</span>
          </span>
          <span class="gx-wallet__modal-price-v">¥{{ payPrice }}</span>
        </div>
        <recharge-campaign-tip :visible="payShow" :computing-power-type="3" :quantity="payType===1 ? thisNum : otherNum" />

        <div class="gx-wallet__modal-tip">
          <div class="gx-wallet__modal-tip-title">温馨提示</div>
          <div class="gx-wallet__modal-tip-text">
            充值额度只用于临时增加软件有效期内的搬家额度，<span style="color: rgb(245,158,43)">额度用完即止，且不会延长使用时间</span>。如需延长使用时间，请前往 <a href="https://fxg.jinritemai.com/ffa/mopen/application" target="_blank">服务市场订购</a>。
          </div>
        </div>

        <button class="gx-wallet__modal-submit" :disabled="loading" @click="onSubmit">
          {{ loading ? '充值中...' : '立即充值' }}
        </button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
import {mapActions, mapState, mapMutations} from "vuex";
import RechargeCampaignTip from '@/components/recharge/RechargeCampaignTip.vue';

export default {
  components: { RechargeCampaignTip },
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      loading: false,
      payShow: false,
      payFrom: {},
      payType: 1,
      thisNum:'',
      otherNum: '',
      info:{},
      option_list:[],
      unit_price:'',
      min_num:0,
      price:'',
      trade_no:'',
      unit:'',
      userInfo:{}
    };
  },

  created() {
  },
  mounted() {
  },
  computed:{
    payPrice(){
      if(this.payType==1){
        return Number(this.unit_price*this.thisNum).toFixed(2) || 0.00
      }else{
        return Number(this.unit_price*this.otherNum).toFixed(2)|| 0.00
      }
    }
  },
  methods: {
    ...mapActions({
      packageList: "ucenter/getPackageList",
      packageCheckOrder: "ucenter/getpackageCheckOrder",
      opComputingPowerRecharge: "ucenter/opComputingPowerRecharge",
    }),
    show(row) {
      this.info = row||{}
      this.payType = 1
      this.otherNum = ''
      this.price = ''
      this.getList()
      this.payShow = true
    },
    getList() {
      let param = {}
      this.packageList({
        data: param, success: (res) => {
          if (res.code == 200) {
            this.option_list = res.data.option_list
            this.userInfo = res.data.info
            this.unit = res.data.unit
            this.unit_price = Number(res.data.unit_price)
            this.min_num = Number(res.data.min_num||0)
            if(res.data.option_list.length){
              this.thisNum = res.data.option_list[0]
            }
          } else {
            this.$message({message: res.msg, type: 'error'})
          }
        }
      })
    },
    onGoodsPay(type,item) {
      this.payType = type
      if(type===1){
        this.thisNum = item
      }
    },
    inpNum(e){
      let val = e.target.value
      if(val < this.min_num){
        this.$message.warning('最小充值数量为'+this.min_num+'个');
        this.otherNum = this.min_num
      }
    },
    onSubmit() {
      if (this.loading)  return
      let num = this.thisNum
      if(this.payType==2){
        num = this.otherNum
      }
      if (!/^[1-9]\d{0,13}$/.test(String(num)) || Number(num) < this.min_num) {
        this.$message.warning('请输入正整数充值数量');
        return
      }
      this.loading = true
      this.opComputingPowerRecharge({
        data: {num}, success: (res) => {
          this.loading = false
          if (res.code == 200) {
            this.$message.success('充值成功')
            this.payShow = false
            this.$emit('success')
            /*  this.trade_no = res.data.trade_no
              this.$confirm('支付中...', '提示', {
                confirmButtonText: '支付完成',
                cancelButtonText: '遇到问题',
                type: 'warning',
                center: true
              }).then(() => {
                console.log('支付完成')
                this.getCheckOrder()
              }).catch(() => {
                console.log('遇到问题')
              });
              let divForm = document.getElementsByTagName('divform')
              if (divForm.length) {
                document.body.removeChild(divForm[0])
              }
              const div = document.createElement('divform');
              div.innerHTML = res.data.pay_data;
              document.body.appendChild(div);
              document.forms['alipaysubmit'].setAttribute('target', '_blank')
              document.forms['alipaysubmit'].submit();*/
          } else {
            this.$message({message: res.message, type: 'error'})
          }
        }
      })
    },

    getCheckOrder() {
      let param = { trade_no:this.trade_no}
      this.packageCheckOrder({
        data: param, success: (res) => {
          if (res.code == 200) {
            this.$message.success(res.msg)
            this.payShow = false
            this.$emit('success')
          } else {
            this.$message({message: res.msg, type: 'error'})
          }
        }
      })
    },

    formatTime(time){
      if(!time) return ''
      const date = new Date(time * 1000)
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      return `${year}-${month}-${day}`
    },
  },

}
</script>


<style scoped>

.paySelect {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.norBox {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 2px 12px;
  margin-right: 10px;
  cursor: pointer;
  width: fit-content;
  margin-bottom: 10px;
}

.hovBox {
  background: rgb(196, 237, 255);
  border: 1px solid rgb(196, 237, 255);
}

</style>
<style scoped>
.gx-wallet__modal-body {

}
.gx-wallet__modal-label {
  font-size: 11px;
  color: #6A6A8A;
  letter-spacing: .08em;
  text-transform: uppercase;
  margin-bottom: 10px;
}
.gx-wallet__modal-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  margin-bottom: 18px;
}
.gx-wallet__modal-amt {
  padding: 10px 0px;
  border-radius: 8px;
  cursor: pointer;
  text-align: center;
  background: rgb(245, 240, 232);
  border: 2px solid rgb(224, 224, 236);
  transition: 0.18s;
}
.gx-wallet__modal-amt--on {
  background: rgb(255, 245, 245);
  border: 2px solid rgb(200, 68, 60);
}
.gx-wallet__modal-amt-v {
  font-family: 'JetBrains Mono', monospace;
  font-size: 14px;
  font-weight: 700;
  color: rgb(26, 26, 46);
}
.gx-wallet__modal-amt--on .gx-wallet__modal-amt-v {
  color: rgb(200, 68, 60);
}
.gx-wallet__modal-amt-u {
  font-size: 10px;
  color: #6A6A8A;
  margin-top: 3px;
}
.gx-wallet__modal-shop {
  margin-bottom: 14px;
}
.gx-wallet__modal-price {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border-radius: 10px;
  background: #F5F0E8;
  border: 1px solid #E1E5EE;
  margin-top: 18px;
  margin-bottom: 14px;
  font-size: 13px;
  color: #4A4A6A;
}
.gx-wallet__modal-price-v {
  font-family: 'JetBrains Mono', monospace;
  font-size: 18px;
  font-weight: 700;
  color: #D4A946;
}
.gx-wallet__modal-tip {
  padding: 10px 13px;
  border-radius: 8px;
  background: rgb(230, 244, 255);
  border: 1px solid rgb(145, 202, 255);
  margin-bottom: 16px;
}
.gx-wallet__modal-tip-title {
  font-size: 11px;
  color: rgb(22, 119, 255);
  font-weight: 600;
  margin-bottom: 4px;
}
.gx-wallet__modal-tip-text {
  font-size: 11px;
  color: rgb(74, 74, 106);
  line-height: 1.7;
}
.gx-wallet__modal-submit {
  width: 100%;
  height: 42px;
  border-radius: 10px;
  cursor: pointer;
  background:  linear-gradient(135deg, rgb(200, 68, 60), rgb(240, 117, 117));
  border: none;
  font-size: 15px;
  font-weight: 700;
  color: #F4F6F8;
  box-shadow: rgba(255, 77, 79, 0.3) 0px 0px 14px;
  transition: all .2s;
}
.gx-wallet__modal-submit:hover {
  transform: scale(1.02);
}
.gx-wallet__modal-submit:disabled {
  opacity: .5;
  cursor: not-allowed;
  transform: none;
}
</style>
